import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import { useIntl } from "react-intl";

const EditIconButton = (props: IconButtonProps) => {
  const { formatMessage: t } = useIntl();
  return (
    <Tooltip title={t({ id: "editLabel" })}>
      <IconButton {...props}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
};

export default EditIconButton;
